import { render, staticRenderFns } from "./ReferrerCategoryInput.vue?vue&type=template&id=5f6b4b9b&"
import script from "./ReferrerCategoryInput.vue?vue&type=script&lang=ts&"
export * from "./ReferrerCategoryInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports